import { render } from "./FinancialDocument.vue?vue&type=template&id=67acb639&scoped=true"
import script from "./FinancialDocument.vue?vue&type=script&lang=js"
export * from "./FinancialDocument.vue?vue&type=script&lang=js"

import "./FinancialDocument.vue?vue&type=style&index=0&id=67acb639&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67acb639"]])

export default __exports__